import {
  Typography,
  TextField,
  Box,
  Grid,
  styled,
  type GridProps,
} from '@mui/material';
import Color from 'color';
import SelectBase from '../../../../../../../primeX-underwriter/components/footer/SelectBase';
import {
  UW_PANEL_HEADER_MIN_HEIGHT,
  UW_PANEL_HEADER_PADDING_Y,
  UW_PANEL_HEADING_FONT_SIZE,
  UW_PANEL_HEADING_WEIGHT,
  UW_ROW_PADDING_Y,
  UW_COMPONENT_ROW_PADDING_X,
  UW_SECTION_TITLE_FONT_SIZE,
} from '../../uwTileSpacing';
import { UW_VIEW_SCOPE } from '../../../../../../../../../themes/viewScopes';

// These render in the agency quote views as well. Each keeps its original
// values; the underwriter view's sizing applies only under `UW_VIEW_SCOPE`.

export const StyledGrid = styled(Grid)(({ theme }) => {
  return {
    padding: '0.75rem 0.5rem',
    alignItems: 'center',
    minHeight: '4rem',
    [UW_VIEW_SCOPE]: {
      padding: `${UW_PANEL_HEADER_PADDING_Y} ${UW_COMPONENT_ROW_PADDING_X}`,
      minHeight: UW_PANEL_HEADER_MIN_HEIGHT,
    },
    borderRadius: '4px 4px 0 0',
    backgroundColor:
      theme.palette.mode === 'dark'
        ? theme.config.colors.charcoal
        : Color(theme.palette.background.default).lighten(0.02).toString(),
  };
});

export const Heading = styled(Box)(() => ({
  fontSize: '1.1rem',
  fontWeight: 'bold',
  textAlign: 'center',
  [UW_VIEW_SCOPE]: {
    fontSize: UW_PANEL_HEADING_FONT_SIZE,
    fontWeight: UW_PANEL_HEADING_WEIGHT,
  },
}));

export const CoverageLineItemContainer = styled((props: GridProps) => (
  <Grid container {...props} />
))(({ theme }) => {
  return {
    padding: '0.75rem 0.5rem',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    minHeight: 52,
    [UW_VIEW_SCOPE]: {
      padding: `${UW_ROW_PADDING_Y} ${UW_COMPONENT_ROW_PADDING_X}`,
    },
  };
});

export const StyledSelect = styled(SelectBase)(() => {
  return {
    width: 120,
    height: '2.5rem',
    background: 'transparent',
    '& .MuiOutlinedInput-root': {
      height: '0.5rem',
      width: 100,
      background: 'transparent',
    },
  };
});

export const StyledTextField = styled(TextField)(() => {
  return {
    '& .MuiInputBase-input': {
      height: '0.95rem',
      width: '4rem',
      background: 'transparent',
    },
    '& .Mui-disabled': {
      opacity: 0.5,
    },
  };
});

export const StyledHeader = styled(Typography)(() => ({
  fontSize: '24px',
  fontWeight: 'bold',
  [UW_VIEW_SCOPE]: {
    fontSize: UW_SECTION_TITLE_FONT_SIZE,
    fontWeight: UW_PANEL_HEADING_WEIGHT,
  },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}));
